import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { UnsubscribeFeedbackPage } from 'features/emailUnsubscribe'
import { z } from 'zod/v4'

export const unsubscribeFeedbackSchema = z.object({
  unsubscribeId: z.string().optional(),
})

export type UnsubscribeFeedbackSchemaSearch = z.infer<typeof unsubscribeFeedbackSchema>

export const Route = createFileRoute('/unsubscribe/feedback')({
  component: UnsubscribeFeedbackPage,
  validateSearch: unsubscribeFeedbackSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Unsubscribe from feedback emails'),
      },
    ],
  }),
})
